import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import {
  showWalletProviderApprovalGrantedNotification,
  getProviderIdFromPendingApprovalCache,
} from '../wallet/messages/wallet-notifications';

// NOTE: This is a poor man's "offline" messaging inbox feature.
// This hook checks if a seller provider has been granted approval to create labels
// In which the client otherwise would've missed the Pusher event due to being offline
export const useSellerProviderApprovalGrantedChecker = () => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);

  useEffect(() => {
    const providerIdsWaitingApproval = getProviderIdFromPendingApprovalCache();

    if (providerIdsWaitingApproval.length === 0) {
      return;
    }

    providerIdsWaitingApproval.forEach((providerId) => {
      const matchingProvider = sellerLabelProviders.find((provider) => provider.labelProviderId === providerId);

      if (!matchingProvider) {
        return;
      }

      if (matchingProvider.isPendingApprovalToCreateLabel) {
        return;
      }

      showWalletProviderApprovalGrantedNotification(providerId, sellerHomeCountry);
    });
  }, [sellerHomeCountry, sellerLabelProviders]);
};
